import { render, staticRenderFns } from "./WordCategoryDetails.vue?vue&type=template&id=264b0e6a"
import script from "./WordCategoryDetails.vue?vue&type=script&lang=js"
export * from "./WordCategoryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports